import { useContext, useEffect, useMemo, useState } from 'react';

import { useApolloClient } from '@apollo/client';

import { DataContext, DataContextActionType } from '../../../../context/DataContext';

import { GET_LOANS_QUERY } from '../../../../query/getLoans';

import { GetLoansByAssetClass } from '../../../../query/__generated__/getLoans';

type GetLoansByAssetClass_user_company_loans = NonNullable<
  NonNullable<NonNullable<NonNullable<GetLoansByAssetClass>['user']>['company']>['loans']
>[number];
interface Props {
  creModalLoanId: string;
  role: string;
}

const PAGE_SIZE = 10;

export const useCREModal = ({ creModalLoanId, role }: Props) => {
  const client = useApolloClient();
  const { dispatch } = useContext(DataContext);

  const [allLoans, setAllLoans] = useState<GetLoansByAssetClass_user_company_loans[]>([]);
  const [loadingLoansList, setLoadingLoansList] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [selectedLoanId, setSelectedLoanId] = useState<string>(creModalLoanId);

  useEffect(() => {
    const fetchAll = async () => {
      setLoadingLoansList(true);
      let accumulated: any[] = [];
      let offset = 0;
      let hasMore = true;

      while (hasMore) {
        const { data } = await client.query({
          query: GET_LOANS_QUERY,
          variables: { assetClass: 'CRE', offset: offset },
          fetchPolicy: 'no-cache',
        });

        const loans = data?.user?.company?.loans ?? [];

        accumulated = [...accumulated, ...loans];

        if (loans.length < PAGE_SIZE) {
          hasMore = false;
          setAllLoans(accumulated);
          setLoadingLoansList(false);
        }

        offset += PAGE_SIZE;
      }
    };

    fetchAll();
  }, [role]);

  const filteredLoans = useMemo(() => {
    return allLoans
      ?.filter((item) => item.account_id)
      .filter((item) => item.account_id!.toLowerCase().includes(searchValue.toLowerCase()));
  }, [allLoans, searchValue]);

  useEffect(() => {
    dispatch({
      type: DataContextActionType.SET_LOADING,
      payload: loadingLoansList,
    });
  }, [loadingLoansList]);

  return {
    data: filteredLoans.length > 0 ? filteredLoans : [],
    loadingLoansList,
    searchValue,
    setSearchValue,
    selectedLoanId,
    setSelectedLoanId,
  };
};
